import React, { useContext, useEffect, useRef, useState } from "react";
import "../Style/podcastDetailsPage.css";
import { MyComponent, scrollToTop } from "./Methods";
import NavsList from "./NavsList";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AppContext } from '../App';
import PodcastGrid from "./PodcastGrid";
import Comment from "./Comment";
export default function PodcastDetailsPage(){
    const [isLoading,setIsLoading] = useState(true);
    const [data,setData] = useState({
        title : "",
    });
    const navigate = useNavigate();
    const firstLoad = useRef(true);
    const params = useParams();
    const {playerInfo} = useContext(AppContext);
    const [player,setPlayer] = playerInfo;
    const [showFullDesc,setShowFullDesc] = useState("");
    function podcastClickHandler(){
        setPlayer({
            url:"/podcast/1",
            title : "پادکست شماره ۵",
            cover : "/image/podcastImg.jpg",
            duration : "۱۰:۰۰",
            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
        });
    }

    useEffect(() => {
        if(!params.id){
            navigate("/");
        }
        scrollToTop();
        if(firstLoad.current){
            firstLoad.current = false;
            const data = new FormData();
            data.append("id", params.id);
            fetch("https://web.bamamiresi.com/Enrollment/GetPodCast",{
                method:"POST",
                body:data,
            })
            .then((res) => {
                if (!res.ok) {
                throw new Error("102");
                }
                return res.json();
            })
            .then((json) => {
                if (json.error) {
                    throw new Error(json.msg);
                }
                // scrollToTop();
                // setIsLoading(false);
                // setData(json[0]);
            })
            .catch((err) => {
                navigate("/505");
            });
            setTimeout(() => {
                setData({
                    title : "پادکست راز موفقیت",
                    img : "https://chekida.com/media/cache/7f/82/7f820a282abb9fd7c0405c14d69ae416.jpg",
                    author : "نوید کریمی",
                    authorId : 1,
                    src : "https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                    category : "سینما و تئاتر",
                    duration : "۱۰:۰۰",
                    visit : 150,
                    description : "<p>حسرت، یکی از سنگین‌ترین حس‌هایی که میشه باهاش روبه‌رو شد. این حس مثل یه سایه‌ست که همیشه پشت سرمون میاد، هر جا می‌ریم و هر تصمیمی که می‌گیریم، خودش رو بهمون یادآوری می‌کنه.</p><p>از همه بدتر اینکه درد حسرت تا سال‌ها با ما همراه می‌مونه. </p><a>مشاهده توضیحات</a><p>خلاصه کتاب حسرت و فرصت اثر دن سالیوان و بنجامین هاردی راهی برای بیشتر بهره‌بردن از زندگیه؛ اونم بدون اینکه اسیر حسرت‌هایی بشیم که شاید همین الان توی ذهنمون جا خوش کرده باشن.</p><p>این کتاب می‌خواد بهمون یاد بده که چطور می‌تونیم با تغییر ذهنیتمون، دیدگاه‌مون نسبت به موقعیت‌های مختلف زندگی رو تغییر بدیم. وقتی به جایی می‌رسیم که دو تا انتخاب داریم – یکی که راحت و بی‌خطره، و یکی دیگه که شاید ریسکی باشه ولی پتانسیل بزرگی برای موفقیت داره – سالیوان می‌گه باید به دومی فکر کنیم. چون هر چی بیشتر به سمت فرصت‌ها بریم، کمتر اسیر حسرت می‌شیم.</p><p>یه نکته جالب دیگه که سالیوان توی کتابش مطرح می‌کنه، اینه که حسرت‌ها همیشه از کارهایی که انجام ندادیم، شکل می‌گیرن. اون لحظه‌هایی که به جای اینکه دست به عمل بزنیم، نشستیم و تماشا کردیم؛ بنابراین اگه آدم عملگرایی نیستی اما توی سرت پر از ایده‌ها و فکره، حتما این کتاب می‌تونه خیلی کمکت کنه.</p><p>«حسرت و فرصت» کتابیه که بهمون کمک می‌کنه بفهمیم کجاها تو زندگی داریم از روی ترس عقب‌نشینی می‌کنیم و چطور می‌تونیم این عادت رو ترک کنیم. به قول سالیوان، زندگی پر از فرصت‌هاییه که فقط منتظرمون هستن، ولی باید جراتش رو داشته باشیم که بهشون نزدیک بشیم و ازشون استفاده کنیم. چون در نهایت، کسی که فرصت‌ها رو می‌قاپه، همونیه که کمتر اسیر حسرت‌ها میشه.</p>",
                    isInCart : false,
                    discount : 10,
                    price : 200000,
                    related : [
                        {
                            url:"/podcast/1",
                            title : "پادکست شماره ۵",
                            cover : "/image/podcastImg.jpg",
                            duration : "۱۰:۰۰",
                            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                            discount : 10,
                            price: 200000
                        },
                        {
                            url:"/podcast/1",
                            title : "پادکست شماره ۵",
                            cover : "/image/podcastImg.jpg",
                            duration : "۱۰:۰۰",
                            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                            discount : 10,
                            price: 200000
                        },
                        {
                            url:"/podcast/1",
                            title : "پادکست شماره ۵",
                            cover : "/image/podcastImg.jpg",
                            duration : "۱۰:۰۰",
                            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                        },
                        {
                            url:"/podcast/1",
                            title : "پادکست شماره ۵",
                            cover : "/image/podcastImg.jpg",
                            duration : "۱۰:۰۰",
                            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                            discount : 10,
                            price: 200000
                        },
                        {
                            url:"/podcast/1",
                            title : "پادکست شماره ۵",
                            cover : "/image/podcastImg.jpg",
                            duration : "۱۰:۰۰",
                            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                            discount : 10,
                            price: 200000
                        },
                        {
                            url:"/podcast/1",
                            title : "پادکست شماره ۵",
                            cover : "/image/podcastImg.jpg",
                            duration : "۱۰:۰۰",
                            src:"https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
                            discount : 10,
                            price: 200000
                        },
                    ],
                    totalRate : 4.25,
                    totalRateNumber : 25 ,
                    commentsList : [
                        {
                            userName : "محمد کریمی",
                            rate : 5,
                            comment : "عالی بود ممنون از تیم هوشمند چکیده ممنون از جناب محمدپور که با استادی ، مطالب مهم رو با هنر و صداشون متمایز می کردن خواهش می کنم در چکیده کردن کتابها امانت و حق مطلب اصلی رو ادا کنین",
                            adminAnswer : "چکیدا عالی هستی فقط دو مورد ۱..اگه قابلیت مارک کردن سطرهای مهمو اضافه میکردی عالی بود"
                        },
                        {
                            userName : "محمد کریمی",
                            rate : 4,
                            comment : "عالی بود ممنون از تیم هوشمند چکیده ممنون از جناب محمدپور که با استادی ، مطالب مهم رو با هنر و صداشون متمایز می کردن خواهش می کنم در چکیده کردن کتابها امانت و حق مطلب اصلی رو ادا کنین",
                            adminAnswer : ""
                        },
                    ],
                    commentsTotalNumber : 5
                });
                setIsLoading(false);
                scrollToTop();
            }, 200);
        }
    }, []);
    return <>
        {
            isLoading ? <section className="flex flexCol podcastDetailsLoadingSection container">
                <div className="flex flexCol podcastDetailsRouteLoading rel">
                    <div className="loaderItem"></div>
                </div>
                <div className="grid podcastDetailsLoadingContent">
                    <div className="flex flexCol podcastDetailsImgLoading rel">
                        <div className="loaderItem"></div>
                    </div>
                    <div className="flex flexCol podcastInfoLoadingDiv">
                        <div className="flex flexCol podcastTextLoading rel">
                            <div className="loaderItem"></div>
                        </div>
                        <div className="flex flexCol podcastTextLoading rel">
                            <div className="loaderItem"></div>
                        </div>
                        <div className="flex flexCol podcastTextLoading rel">
                            <div className="loaderItem"></div>
                        </div>
                    </div>
                </div>
            </section> :
            <>
                <NavsList data={[{name:"پادکست ها",link:"/podcasts"},{name:data.title,link:""}]} />
                <main className="podcastDetailsSection grid container">
                    <div className="flex flexCol podcastLeftDiv">
                        <img src={data.img} alt={data.title} className="podcastDetailsMainImg" width={250} draggable="false"/>
                        <div className="flex flexCol podcastBtnsDiv">
                        {
                            data.price > 0 ? <div className="grid podcastPlayDiv">
                                <button className="flex flexCenter playPodcast" onClick={()=>podcastClickHandler()}>
                                    <p className="faFont flex alignCenter textSize14 playPodcastText">
                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path></svg>
                                        {
                                            data.price > 0 ? "شنیدن پادکست" : "شنیدن خلاصه پادکست"
                                        }
                                    </p>
                                </button>
                                <a href={data.src} className="flex flexCenter dlPodcastBtn textSize1" target="_blank">
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.35em" width="1.35em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"></path></svg>
                                    <span className="hideText">دانلود</span>
                                </a>
                            </div> :
                            <button className="flex flexCenter playPodcast" onClick={()=>podcastClickHandler()}>
                                <p className="faFont flex alignCenter textSize14 playPodcastText">
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path></svg>
                                    شنیدن خلاصه پادکست
                                </p>
                            </button>
                        }
                        </div>
                    </div>
                    <div className="flex flexCol podcastRightDiv">
                        <h1 className="faFont textSize16 textClr3 podcastDetailsName">
                            {
                                data.title
                            }
                        </h1>
                        <Link to={`/teachers/${data.authorId}`} className="faFont textSize1 textClr5 podcastAuthor">
                            {
                                data.author
                            }
                        </Link>
                        <div className="flex podcastInfoDiv">
                            <Link to={`/podcasts?cat=${data.category}`} className="faFont textSize1 textClr5 flex alignCenter podcastCategory gap5">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 10h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"></path></svg>
                                {
                                    data.category
                                }
                            </Link>
                            <p className="faFont textSize1 textClr5 podcastDetailsDuration flex gap5 alignCenter">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M16.24 7.76A5.974 5.974 0 0 0 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 0 0-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></svg>
                                {
                                    data.duration
                                }
                            </p>
                            <p className="faFont textSize1 textClr5 podcastDetailsDuration flex gap5 alignCenter">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>
                                {
                                    data.visit
                                }
                            </p>
                        </div>
                        <div className={`flex flexCol podcastDescriptionDiv ${showFullDesc}`}>
                            <h2 className="faFont textClr3 textSize12 podcastDescriptionTitle rel">
                                درباره پادکست
                            </h2>
                            <div className="flex flexCol podcastDescriptionDivList faFont">
                                {
                                    MyComponent({htmlContent:data.description})
                                }
                            </div>
                            <button className="showFullDescription flex alignCenter faFont textSize9 textClr3" onClick={()=>setShowFullDesc("full")}>
                                مشاهده بیشتر
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path></svg>
                            </button>
                        </div>
                        <div className="flex flexCol addToCartDiv">
                            <div className="grid addToCartSubDiv">
                                <div className="flex flexCol addToCartRightDiv">
                                    {
                                        data.isInCart ? 
                                        <button className="removeFromCart flex flexCenter alignCenter faFont textSize11 textClrF">
                                            <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>
                                            حذف از سبد خرید
                                        </button> : 
                                        <button className="addToCartBtn flex flexCenter alignCenter faFont textSize11 textClrF">
                                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"></path></svg>
                                            افزودن به سبد خرید
                                        </button>
                                    }
                                </div>
                                <div className="flex flexCol addToCartPriceDiv rel">
                                    {
                                        data.discount > 0 ? <>
                                            <p className="faFont flex alignCenter textSize9 textClr7 addToCartOffPrice">
                                                <span className="value">{ data.price.toLocaleString() }</span>
                                            </p>
                                            <p className="faFont flex alignCenter textSize1 textClr5 addToCartOffPercent">
                                                <span className="value flex alignCenter">
                                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 384 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"></path></svg>
                                                    {
                                                        data.discount
                                                    }
                                                </span>
                                            </p>
                                            <p className="faFont flex alignCenter textSize12 textClr3 addToCartRealPrice">
                                                <span className="value">{(+data.price - ((+data.price * +data.discount) / 100)).toLocaleString()}</span>
                                                <span className="textSize9">تومان</span>
                                            </p>
                                        </> : <>
                                            <p className="faFont flex alignCenter textSize12 textClr3 addToCartRealPrice">
                                                <span className="value">{data.price.toLocaleString()} </span>
                                                <span className="textSize9">تومان</span>
                                            </p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <section className="flex flexCol container relativePodcastsSection">
                    <h3 className="faFont textSize12 textClr3 podcastDescriptionTitle">
                        پادکست های مشابه
                    </h3>
                    <PodcastGrid data={data.related} part={{
                        titleLogo : <svg stroke="currentColor" fill="currentColor" strokeWidth="0" role="img" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M1.503 9.678c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0v-1.63c0-.83-.67-1.5-1.5-1.5zm20.994 0c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0v-1.63c0-.83-.67-1.5-1.5-1.5zM6.68 14.587c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0v-1.62c0-.83-.67-1.5-1.5-1.5zm0-9.817c-.83 0-1.5.67-1.5 1.5v5.357a1.5 1.5 0 003 0V6.258c0-.83-.67-1.5-1.5-1.5zm10.638 0c-.83 0-1.5.67-1.5 1.5v1.64a1.5 1.5 0 003 0V6.27c0-.83-.67-1.5-1.5-1.5zM12 0c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0V1.5c0-.83-.67-1.499-1.5-1.499zm0 19.355c-.83 0-1.5.67-1.5 1.5v1.64a1.5 1.5 0 103 .01v-1.64c0-.82-.67-1.5-1.5-1.5zm5.319-8.457c-.83 0-1.5.68-1.5 1.5v5.328a1.5 1.5 0 003 0v-5.329c0-.83-.67-1.5-1.5-1.5zM12 6.128c-.83 0-1.5.68-1.5 1.5v8.728a1.5 1.5 0 003 0V7.638c0-.83-.67-1.5-1.5-1.5z"></path></svg>,
                        titleText : "پادکست ها",
                        linkLogo : <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path></svg>,
                        linkText : "همه پادکست ها",
                    }}/>
                </section>
                <Comment data={{totalRate:data.totalRate , totalRateNumber : data.totalRateNumber ,comments : data.commentsList ,totalComments : data.commentsTotalNumber}} />
            </>
        }
    </>
}